import RecentlyViewedProducts from './recently-viewed-products';
export default RecentlyViewedProducts;